import type { Overlay } from '@shared/types'
import { OVERLAY_KIND_TO_LANE, type OverlayLaneKey } from '../../../lib/timelineMath'

// NOTE: px/sec is no longer a fixed constant — zoom is dynamic (editorStore
// zoomPxPerSec/effectivePxPerSec, resolved via lib/timelineMath's fit/clamp
// helpers) and threaded down as a `pxPerSec` prop. Only fixed pixel LAYOUT
// constants live here.
export const RULER_H = 24
export const VIDEO_LANE_H = 72
export const AUDIO_LANE_H = 44

/** 左のトラックヘッダー列（レーン名）の幅。CapCut 参照仕様 §1 の ~40px 相当。 */
export const TRACK_HEADER_W = 48

export const OVERLAY_SUBLANE_H = 22
export const OVERLAY_SUBLANE_EMPTY_H = 10

export const OVERLAY_LANE_ORDER: { key: OverlayLaneKey; label: string }[] = [
  { key: 'card', label: 'カード' },
  { key: 'label', label: 'ラベル' },
  { key: 'logo', label: 'ロゴ' },
  { key: 'text', label: 'テキスト' },
]

export function overlayLaneHeight(overlays: Overlay[], lane: OverlayLaneKey): number {
  const has = overlays.some((o) => OVERLAY_KIND_TO_LANE[o.kind] === lane)
  return has ? OVERLAY_SUBLANE_H : OVERLAY_SUBLANE_EMPTY_H
}

export function overlayLanesTotalHeight(overlays: Overlay[]): number {
  return OVERLAY_LANE_ORDER.reduce((sum, l) => sum + overlayLaneHeight(overlays, l.key), 0)
}

export const SEGMENT_REORDER_MIME = 'application/x-aquacut-segment-reorder'

/** 吸着の許容量（px）。秒への換算は呼び出し側で pxPerSec を使う（8px / pxPerSec）。 */
export const SNAP_TOLERANCE_PX = 8

/** Toolbar の高さ（task spec §2-13: 32px）。 */
export const TOOLBAR_H = 32
